module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-1-small-c3ab73375c06e6a76d5112045e939e27.jpg";